import React, { useState, useEffect, Fragment, useMemo } from 'react';
import Joi from '@hapi/joi';
import {
    Avatar,
    Box,
    Card,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    Typography,
    Select
} from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import services from '../Services';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import PinDropIcon from '@material-ui/icons/PinDrop';
import StraightenIcon from '@material-ui/icons/Straighten';
import EventIcon from '@material-ui/icons/Event';
import CountUp from 'react-countup';
import { CardContentData } from './CardContentData';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { validate, validateProperty } from "../../../Common";
import { PluckingChartReportObject } from '../PluckingChartReportSchema';
import { PageHeader } from '../../../../Common';
import { Snackbar, Alert } from "@mui/material";


const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
    },
    rootx: {
        borderRadius: 16,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        transition: '0.3s',
        backgroundColor: '#ffffff',
        '&:hover': {
            transform: 'scale(1.3)',
        },
    },
    cardContent: {
        textAlign: 'center',
        padding: theme.spacing(2),
    },
    avatar: {
        margin: '0 auto 12px'
    },
    fieldName: {
        fontSize: '16px',
        fontWeight: 600,
        marginBottom: 10,
        color: '#333',
    },
    valueText: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#444',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 4,
    },
}));

const getCardColor = (value, qty) => {
    if (value > 7) return '#ffe0e0';
    else if (value === 0 && qty === 0) return '#e1e2e6';
    return '#cfffcc';
};

const getIconColor = (value, qty) => {
    if (value > 7) return '#c40202';
    else if (value === 0 && qty === 0) return '#56585c';
    return '#0e8c16';
};

const screenCode = 'PLUCKINGCHART';

export function PluckingChartReport(props) {
    const [title, setTitle] = useState("Field Analysis");
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    // const [companies, setCompanies] = useState([]);
    // const [regions, setRegions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState();
    const [labourTask, setLabourTask] = useState();
    const [selectFieldID, setSelectedFieldID] = useState(0);
    const [dialogbox, setDialogbox] = useState(false);
    const currentDate = new Date();
    const [toDate, setToDate] = useState(currentDate);
    const [fromDate, setFromDate] = useState(() => calculateFromDate(currentDate));
    const [pluckingChartReportData, setPluckingChartReportData] = useState([]);
    const [pluckingChartReport, setPluckingChartReport] = useState({
        groupID: 0,
        // companyID: 0,
        // regionID: 0,
        estateID: 0,
        divisionID: 0,
        taskID: 0,
        // fieldTypes: 0
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [clearAutoComplete, setClearAutoComplete] = useState(false)
    const [errors, setErrors] = useState({});
    const [alertConfig, setAlertConfig] = useState({
        open: false,
        message: "",
        severity: "info"
    });

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertConfig({ ...alertConfig, open: false });
    };

    const schema = Joi.object(PluckingChartReportObject).options({ allowUnknown: true })

    const [selectedEstate, setSelectedEstate] = useState(null);
    const [selectedDivision, setSelectedDivision] = useState(null);

    const divisionOptions = Object.entries(divisions || {})
        .map(([k, v]) => ({ id: String(k), label: v }))
        .sort((a, b) => String(a?.label ?? '').localeCompare(String(b?.label ?? ''), undefined, { sensitivity: 'base' }));
    const estateOptions = Object.entries(estates || {})
        .map(([k, v]) => ({ id: String(k), label: v }))
        .sort((a, b) => String(a?.label ?? '').localeCompare(String(b?.label ?? ''), undefined, { sensitivity: 'base' }));

    const taskOptions = useMemo(() => {
        return (labourTask || [])
            .slice()
            .sort((a, b) => {
                const aLabel = `${a?.taskCode ?? ''} - ${a?.taskName ?? ''}`;
                const bLabel = `${b?.taskCode ?? ''} - ${b?.taskName ?? ''}`;
                return aLabel.localeCompare(bLabel, undefined, { sensitivity: 'base' });
            });
    }, [labourTask]);

    useEffect(() => {
        const sel = pluckingChartReport.estateID && String(pluckingChartReport.estateID) !== "0"
            ? estateOptions.find(o => o.id == String(pluckingChartReport.estateID))
            : null;
        setSelectedEstate(sel || null);
    }, [pluckingChartReport.estateID, estates]);

    useEffect(() => {
        const sel = pluckingChartReport.divisionID && String(pluckingChartReport.divisionID) !== "0"
            ? divisionOptions.find(o => o.id == String(pluckingChartReport.divisionID))
            : null;
        setSelectedDivision(sel || null);
    }, [pluckingChartReport.divisionID, divisions]);

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    // useEffect(() => {
    //     trackPromise(getCompanyDetailsByGroupID());
    // }, [pluckingChartReport.groupID]);

    // useEffect(() => {
    //     trackPromise(getRegionDetailsByCompanyID());
    // }, [pluckingChartReport.companyID]);

    useEffect(() => {
        trackPromise(getEstateDetailsByGroupID());
    }, [pluckingChartReport.groupID]);

    useEffect(() => {
        trackPromise(getDivisionDetailsByEstateID());
    }, [pluckingChartReport.estateID]);

    useEffect(() => {
        trackPromise(GetTasksByOperationEntityID());
    }, [pluckingChartReport.estateID]);

    useEffect(() => {
        setClearAutoComplete(!clearAutoComplete)
        setPluckingChartReport({
            ...pluckingChartReport,
            // companyID: '0',
            // regionID: '0',
            estateID: '0',
            divisionID: '0',
            taskID: '0',
            // fieldTypes: '0'
        })
    }, [pluckingChartReport.groupID])

    // useEffect(() => {
    //     setClearAutoComplete(!clearAutoComplete)
    //     setPluckingChartReport({
    //         ...pluckingChartReport,
    //         regionID: '0',
    //         estateID: '0',
    //         divisionID: '0',
    //         taskID: '0',
    //         fieldTypes: '0'
    //     })
    // }, [pluckingChartReport.companyID])

    // useEffect(() => {
    //     setClearAutoComplete(!clearAutoComplete)
    //     setPluckingChartReport({
    //         ...pluckingChartReport,
    //         estateID: '0',
    //         divisionID: '0',
    //         taskID: '0',
    //         fieldTypes: '0'
    //     })
    // }, [pluckingChartReport.regionID])

    useEffect(() => {
        setClearAutoComplete(!clearAutoComplete)
        setPluckingChartReport({
            ...pluckingChartReport,
            divisionID: '0',
            taskID: '0',
            fieldTypes: '0'
        })
    }, [pluckingChartReport.estateID])

    useEffect(() => {
        setClearAutoComplete(!clearAutoComplete)
        setPluckingChartReport({
            ...pluckingChartReport,
            taskID: '0',
            fieldTypes: '0'
        })
    }, [pluckingChartReport.divisionID])

    useEffect(() => {
        setPluckingChartReport({
            ...pluckingChartReport,
            fieldTypes: '0',
        })
    }, [pluckingChartReport.taskID])

    useEffect(() => {
        setPluckingChartReportData([]);
    }, [pluckingChartReport, fromDate, toDate]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPLUCKINGCHART');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token == null || token == undefined) {
            setPluckingChartReport({
                ...pluckingChartReport,
                groupID: "0",
                companyID: "0",
                regionID: "0",
                estateID: "0"
            });
        } else {
            //var ID = await tokenService.getCompanyandRegionIDByOperationEntitiyID(token.operationEntityID);
            setPluckingChartReport({
                ...pluckingChartReport,
                groupID: token.groupID,
                // companyID: ID.data[0].companyID,
                // regionID: ID.data[0].regionID,
                estateID: token.operationEntityID
            });
        }

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    // async function getCompanyDetailsByGroupID() {
    //     var response = await services.getCompanyDetailsByGroupID(pluckingChartReport.groupID);
    //     setCompanies(response);
    // };

    // async function getRegionDetailsByCompanyID() {
    //     var response = await services.getRegionDetailsByCompanyID(pluckingChartReport.companyID);
    //     setRegions(response);
    // };

    async function getEstateDetailsByGroupID() {
        var response = await services.getEstateDetailsByGroupID(pluckingChartReport.groupID);
        console.log(response);
        setEstates(response);
    };

    async function getDivisionDetailsByEstateID() {
        var response = await services.getDivisionDetailsByEstateID(pluckingChartReport.groupID, pluckingChartReport.estateID);
        setDivisions(response);
    };

    async function GetTasksByOperationEntityID() {
        const result = await services.GetTasksByOperationEntityID(pluckingChartReport.estateID)
        setLabourTask(result)
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            const sortedEntries = Object.entries(data).sort((a, b) => a[1].localeCompare(b[1]));
            for (const [key, value] of sortedEntries) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }

        return items;
    }
    function calculateFromDate(toDate) {
        const resultDate = new Date(toDate);
        resultDate.setMonth(resultDate.getMonth() - 1);
        return resultDate;
    }

    const openDialogbox = (fieldID) => {
        setSelectedFieldID(fieldID);
        setDialogbox(true);
    };

    const visibleFields = useMemo(() => {
        const taskID = Number(pluckingChartReport.taskID) || 0;
        if (taskID <= 0) return pluckingChartReportData || [];
        return (pluckingChartReportData || []).filter(field => {
            if (!field || !field.details) return false;
            return field.details.some(d => Number(d.taskID) === taskID);
        });
    }, [pluckingChartReportData, pluckingChartReport.taskID]);
    function closeDialogbox() {
        setDialogbox(false)
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(pluckingChartReport.groupID),
            companyID: parseInt(pluckingChartReport.companyID),
            regionID: parseInt(pluckingChartReport.regionID),
            estateID: parseInt(pluckingChartReport.estateID),
            divisionID: parseInt(pluckingChartReport.divisionID),
            taskID: parseInt(pluckingChartReport.taskID),
            fieldTypes: parseInt(pluckingChartReport.fieldTypes),
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            toDate: moment(toDate).format('YYYY-MM-DD')
        }
        const response = await services.GetPluckingChartReport(model);
        console.log("report response", response);
        if (response.statusCode === "Success" && response.data !== null && response.data.length > 0) {
            setPluckingChartReportData(response.data);
        } else {
            setPluckingChartReportData([]);
            setAlertConfig({
                open: true,
                message: "No records available",
                severity: "error"
            });
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        validateInputs(target);
        setPluckingChartReport({
            ...pluckingChartReport,
            [e.target.name]: value
        });
    }

    function getValidationFormData(formData) {
        return {
            ...formData,
            groupID: parseInt(formData.groupID),
            //companyID: parseInt(formData.companyID),
            //regionID: parseInt(formData.regionID),
            estateID: parseInt(formData.estateID),
            divisionID: parseInt(formData.divisionID),
            fromDate: fromDate,
            toDate: toDate
        };
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, PluckingChartReportObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleGenerate(e) {
        e.preventDefault();

        const formDataForValidation = getValidationFormData(pluckingChartReport);

        const errorMessages = validate(schema, formDataForValidation);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});

        if (errorMessages) return;

        trackPromise(GetDetails());
    }

    function handleSearchDropdownChange(data, e) {
        setPluckingChartReportData([])
        if (data === undefined || data === null) {
            setPluckingChartReport({
                ...pluckingChartReport,
                taskID: '0'
            });
            return;
        } else {
            var valueV = data["taskID"];
            setPluckingChartReport({
                ...pluckingChartReport,
                taskID: valueV.toString()
            });
        }
    }
    return (
        <>
            <Fragment>
                <LoadingSpinerComponent />
                <div className="row">
                    <div className="col-md-12 card">
                        <div className="card">
                            <PageHeader
                                title="Field Analysis"
                            />
                            <div className="card-body">
                                <form onSubmit={(e) => trackPromise(handleGenerate(e))}>
                                    <div className="form-group row">
                                        <div className="col-md-4">
                                            <InputLabel shrink id="groupID">Group *</InputLabel>
                                            <Select
                                                fullWidth
                                                id="groupID"
                                                disabled={!permissionList.isGroupFilterEnabled}
                                                name="groupID"
                                                value={pluckingChartReport.groupID}
                                                onChange={(e) => handleChange(e)}>
                                                <MenuItem value="0">--Select Group--</MenuItem>
                                                {generateDropDownMenu(groups)}
                                            </Select>
                                            {errors["groupID"] && <FormHelperText className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                        </div>
                                        <div className="col-md-4">
                                            <InputLabel shrink id="estateID">Estate *</InputLabel>
                                            <Autocomplete
                                                options={estateOptions}
                                                getOptionLabel={(option) => option?.label || ""}
                                                getOptionSelected={(option, value) => option && value && option.id == value.id}
                                                value={selectedEstate}
                                                onChange={(e, newValue) => {
                                                    setSelectedEstate(newValue || null);
                                                    handleChange({ target: { name: "estateID", value: newValue?.id ?? "0" } });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} fullWidth placeholder='--Select Estate--' variant='standard' />
                                                )}
                                                noOptionsText="No estates"
                                                openOnFocus
                                                disabled={!permissionList.isFactoryFilterEnabled}
                                            />
                                            {errors["estateID"] && <FormHelperText className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                        </div>
                                        <div className="col-md-4">
                                            <InputLabel shrink id="divisionID">Division *</InputLabel>
                                            <Autocomplete
                                                options={divisionOptions}
                                                getOptionLabel={(option) => option?.label || ""}
                                                getOptionSelected={(option, value) => option && value && option.id == value.id}
                                                value={selectedDivision}
                                                onChange={(e, newValue) => {
                                                    setSelectedDivision(newValue || null);
                                                    handleChange({ target: { name: "divisionID", value: newValue?.id ?? "0" } });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} fullWidth placeholder='--Select Division--' variant='standard' />
                                                )}
                                                noOptionsText="No divisions"
                                                openOnFocus
                                            />
                                            {errors["divisionID"] && <FormHelperText className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    <div className="form-group row">

                                        <div className="col-md-4">
                                            <InputLabel shrink id="taskID">
                                                Task
                                            </InputLabel>
                                            <Autocomplete
                                                id="taskID"
                                                key={clearAutoComplete}
                                                options={taskOptions}
                                                getOptionLabel={(option) => (option.taskCode + ' - ' + option.taskName)}
                                                onChange={(e, value) => handleSearchDropdownChange(value, e)}
                                                defaultValue={null}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="taskID"
                                                        fullWidth
                                                        value={pluckingChartReport.taskID}
                                                        getOptionDisabled={true}
                                                        size='small'
                                                        placeholder={"Task Code"}
                                                    />
                                                }
                                            />
                                        </div>
                                        {/* <div className="col-md-4">
                                            <InputLabel shrink id="fieldTypes">Field Types</InputLabel>
                                            <Select
                                                fullWidth
                                                name="fieldTypes"
                                                value={pluckingChartReport.fieldTypes}
                                                id="fieldTypes"
                                                onChange={(e) => handleChange(e)}
                                            >
                                                <MenuItem value="0">--Select Field Types--</MenuItem>
                                                <MenuItem value="1">Mature</MenuItem>
                                                <MenuItem value="2">Immature</MenuItem>
                                            </Select>
                                        </div> */}
                                        <div className="col-md-4">
                                            <InputLabel shrink id="fromDate">From Date*</InputLabel>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    fullWidth
                                                    variant="outlined"
                                                    format="yyyy-MM-dd"
                                                    id="fromDate"
                                                    value={fromDate}
                                                    onChange={(date) => {
                                                        setFromDate(date);
                                                    }}
                                                    maxDate={toDate}
                                                    autoOk
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <div className="col-md-4">
                                            <InputLabel shrink id="toDate">To Date*</InputLabel>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    fullWidth
                                                    variant="outlined"
                                                    format="yyyy-MM-dd"
                                                    id="toDate"
                                                    value={toDate}
                                                    onChange={(date) => {
                                                        setToDate(date);
                                                    }}
                                                    minDate={fromDate}
                                                    maxDate={currentDate}
                                                    autoOk
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <input
                                            type="submit"
                                            disabled={validate(schema, getValidationFormData(pluckingChartReport))}
                                            className="btn btn-primary"
                                            value="Generate"
                                        />
                                    </div>
                                </form>
                            </div>

                            {visibleFields.length > 0 ? (
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div style={{ padding: 24 }}>
                                                <Typography variant="h5" gutterBottom style={{ fontWeight: 600 }}>
                                                    Fields Overview
                                                </Typography>
                                                <br />
                                                <Grid container spacing={3}>
                                                    {visibleFields.map((data, i) => (
                                                        <Grid item xs={12} sm={6} md={3} lg={2}
                                                            style={{
                                                                justifyContent: 'center'
                                                            }}
                                                            key={i}>
                                                            <Card
                                                                className={classes.rootx}
                                                                onClick={() => {
                                                                    openDialogbox(data.fieldID);
                                                                }}
                                                                style={{ backgroundColor: getCardColor(data.differentDaysFromLastPluck, data.totalQuntity) }}
                                                            >
                                                                <CardContent className={classes.cardContent}>
                                                                    <Typography className={classes.fieldName}>
                                                                        {data.fieldName}
                                                                    </Typography>
                                                                    <Avatar style={{ backgroundColor: getIconColor(data.differentDaysFromLastPluck, data.totalQuntity) }} className={classes.avatar}>
                                                                        <PinDropIcon />
                                                                    </Avatar>
                                                                    <Typography className={classes.valueText}>
                                                                        <StraightenIcon style={{ marginRight: 4 }} />
                                                                        <CountUp
                                                                            end={data.fieldArea}
                                                                            suffix=' ac'
                                                                            decimals={2}
                                                                        />
                                                                    </Typography>
                                                                    <Typography className={classes.valueText}>
                                                                        {data.differentDaysFromLastPluck !== 0 && (
                                                                            <EventIcon style={{ marginRight: 4 }} />
                                                                        )}
                                                                        {(data.differentDaysFromLastPluck === 0 && data.totalQuntity > 0) ? (
                                                                            <strong>Plucked Today</strong>
                                                                        ) : (data.differentDaysFromLastPluck === 0 && data.totalQuntity === 0) ? (
                                                                            <strong>Not Plucked</strong>
                                                                        ) : (
                                                                            <CountUp
                                                                                end={data.differentDaysFromLastPluck}
                                                                                suffix={data.differentDaysFromLastPluck === 1 ? ' day' : ' days'}
                                                                            />
                                                                        )}
                                                                    </Typography>
                                                                </CardContent>
                                                            </Card>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                <Snackbar
                    open={alertConfig.open}
                    autoHideDuration={4000}
                    onClose={handleAlertClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    sx={{ marginBottom: '50px' }}
                >
                    <Alert
                        onClose={handleAlertClose}
                        severity={alertConfig.severity}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {alertConfig.message}
                    </Alert>
                </Snackbar>
            </Fragment>
            {dialogbox ?
                <CardContentData
                    dialogbox={dialogbox}
                    setDialogbox={setDialogbox}
                    pluckingChartReportData={pluckingChartReportData}
                    closeDialogbox={closeDialogbox}
                    selectFieldID={selectFieldID}
                    fromDate={moment(fromDate).format('YYYY-MM-DD')}
                    toDate={moment(toDate).format('YYYY-MM-DD')}
                    taskID={pluckingChartReport.taskID}
                />
                : null
            }
        </>
    )
}